/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PosFormConfigCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel", "OtherPaymentTypeView", "LanguageManager",
    function ($scope, $rootScope, dialog, dialogsModel, OtherPaymentTypeView, LanguageManager) {
        var key;
        // hook the passed data to the popin scope
        for (key in dialogsModel) {
            $scope[key] = dialogsModel[key];
        }
        $scope.posFormConfig = {
            view:
                {
                    tab: 1,
                    vatDefaultError: false,
                    otherPaymentTypesError: null,
                    canCreateAnotherPayment: true
                }
        };
        $scope.dialog = dialog;
        $scope.submitting = false;
        $scope.dialogDrror = null;

        //Mock for Oui/Non toggle buttons
        $scope.isEnglishLanguage = function () {
            return LanguageManager.isEnglishLanguage();
        }

        $scope.cancel = function () {
            var opts = this.posView.domainView.otherPaymentTypesView;
            for (var i = 0; i < opts.length;)
                if (opts[i].getModel()) {
                    opts[i].reloadModel();
                    i++;
                } else {
                    opts.splice(i, 1);
                }

            var vats = this.posView.domainView.vatsView;
            for (var i = 0; i < vats.length;)
                if (vats[i].getModel()) {
                    vats[i].reloadModel();
                    i++;
                } else {
                    vats.splice(i, 1);
                }

            this.posView.domainView.loadPosParam();
            dialog.close(false);
        };
        $scope.save = function () {

            if ($scope.canSave()) {
                $scope.submitting = true;
                $scope.dialogDrror = null;

                if (this.posView.domainView.getDefaultVatView() == null) {
                    $scope.posFormConfig.view.vatDefaultError = true;
                    $scope.posFormConfig.view.tab = 1;
                    return;
                }

                let opts = this.posView.domainView.otherPaymentTypesView;
                for (let i = 0; i < opts.length; i++) {
                    opts[i].updateModel();
                }

                let vats = this.posView.domainView.vatsView;
                for (let i = 0; i < vats.length; i++) {
                    vats[i].updateModel();
                }

                this.posView.domainView.savePosParam(
                    () => {
                        $scope.submitting = false;
                        dialog.close(true);
                    },
                    (error) => {
                        $scope.submitting = false
                        $scope.dialogDrror = error;
                    }
                );
            }
        };
        $scope.createOtherPaymentTypeView = function () {
            if (this.posView) {
                if ($scope.checkPaymentTypesNotEmpty()) {
                    let optView = new OtherPaymentTypeView();
                    optView.order = this.posView.domainView.otherPaymentTypesView.length;
                    this.posView.domainView.addOtherPaymentTypeView(optView);
                }
            }
        };

        $scope.checkPaymentTypesNotEmpty = function () {
            $scope.posFormConfig.view.canCreateAnotherPayment = true;
            for (let otherPaymentTypeView of this.posView.domainView.otherPaymentTypesView) {
                if (!otherPaymentTypeView.label || !otherPaymentTypeView.label.trim()) {
                    $scope.posFormConfig.view.canCreateAnotherPayment = false;
                }
            }
            return $scope.posFormConfig.view.canCreateAnotherPayment;
        };

        $scope.onChangeDefaultVatView = function (vatView) {
            let vats = this.posView.domainView.vatsView;
            for (let i = 0; i < vats.length; i++) {
                if (vats[i] !== vatView) {
                    vats[i].isDefault = false;
                }
            }
            if (vatView.isDefault) {
                vatView.isUsable = true;
                $scope.posFormConfig.view.vatDefaultError = false;
            }
        };

        $scope.canSave = function () {
            let canSave = $scope.checkPaymentTypesNotEmpty();
            if (this.posView.domainView.advancePercent > 50 || this.posView.domainView.advancePercent < 0) {
                $scope.posFormConfig.view.tab = 5;
                canSave = false;
            } else if (this.posView.domainView.giftMonthValidity < 1 || this.posView.domainView.giftMonthValidity > 36) {
                $scope.posFormConfig.view.tab = 4;
                canSave = false;
            }
            return canSave;
        };

        $scope.updateAdvancePercentInputArrow = function (amount) {
            this.posView.domainView.advancePercent += amount;
        };

        $scope.updateGiftMonthValidityInputArrow = function (amount) {
            this.posView.domainView.giftMonthValidity += amount;
        };


    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/planningPos/PosFormConfigCtrl.js